/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { Button, Icon } from '@mairistem/composants';
import { Section } from '@mairistem/administres-utils';

import type { Mention, OptionCodeAnts } from '@/types';

interface MentionCardProps {
  mention: Mention;
  /** Options du dropdown « Code ANTS » (catégories ANTS), pour retrouver le libellé. */
  optionsCodeAnts?: OptionCodeAnts[];
  /** Ouvre la mention en modification (AD-12847). Sans elle, pas de bouton. */
  onEdit?: (mention: Mention) => void;
}

const LABEL_STYLE: React.CSSProperties = { fontWeight: 'normal' };

const MentionCard = (props: MentionCardProps) => {
  const { mention, optionsCodeAnts = [], onEdit } = props;

  const libelleCodeAnts = React.useMemo(() => {
    const option = _.find(optionsCodeAnts, (o) => o.value === mention.codeAnts);
    return option?.text ?? String(mention.codeAnts);
  }, [mention.codeAnts, optionsCodeAnts]);

  return (
    <Section title="INFORMATION DE LA MENTION" height="auto">
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5em',
          padding: '12px 14px',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '0.5em',
          }}
        >
          <span style={LABEL_STYLE}>
            Numéro&nbsp;: <strong>{mention.numero}</strong>
          </span>
          <span style={LABEL_STYLE}>
            Apposée le&nbsp;: <strong>{mention.dateApposition}</strong>
          </span>
          {mention.codeAnts !== '' && (
            <span style={LABEL_STYLE}>
              Code ANTS&nbsp;: <strong>{libelleCodeAnts}</strong>
            </span>
          )}
        </div>
        <span style={LABEL_STYLE}>
          Titre&nbsp;: <strong>{mention.titre}</strong>
        </span>
        {!_.isEmpty(mention.texte) && (
          <span style={LABEL_STYLE}>
            Texte&nbsp;:{' '}
            <strong style={{ whiteSpace: 'pre-wrap' }}>{mention.texte}</strong>
          </span>
        )}
        {onEdit && (
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            {/* Icône seule (AD-12847) : le libellé passe en infobulle. */}
            <Button
              basic
              icon
              size="small"
              title="Modifier"
              aria-label="Modifier la mention"
              data-testid="mention-modifier"
              onClick={() => onEdit(mention)}
            >
              <Icon name="pencil" />
            </Button>
          </div>
        )}
      </div>
    </Section>
  );
};

export default MentionCard;
